var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtalase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "_24px_5_",
    width: 18.883,
    height: 18.883,
    "data-name": "24px (5)",
    viewBox: "0 0 18.883 18.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{fill:#a9a8a8}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    d: "M0 0h18.883v18.883H0z",
    className: "cls-1",
    "data-name": "Path 816"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    d: "M16.376 4H3.787v1.574h12.589zm.787 7.868v-1.574l-.787-3.934H3.787L3 10.294v1.574h.787v4.721h7.868v-4.721H14.8v4.721h1.574v-4.721zm-7.081 3.147H5.36v-3.147h4.721z",
    className: "cls-2",
    "data-name": "Path 817",
    transform: "translate(-.64 -.853)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtalase);
export default __webpack_public_path__ + "static/media/etalase.4371acb24a0ed07bdccf66780298d76d.svg";
export { ForwardRef as ReactComponent };